// eslint-disable-next-line
import Symbol_observable from 'symbol-observable';
import React from 'react';
import ReactDOM from 'react-dom';

import { AppContainer } from '@/exceed';

import { ExperienceSSO } from '../src/experienceSSO';

if (import.meta.hot) import.meta.hot.accept();

ReactDOM.render(
  <AppContainer config={{ i18nKey: 'experience_sso' }}>
    <ExperienceSSO />
  </AppContainer>,
  document.getElementById('experience_sso'),
);
